import React, { useEffect, useState } from "react";

import { useRecoilValue, useSetRecoilState } from "recoil";
import useSWR from "swr";

import { BASE_URL, fetcher, sendData } from "../../../Models/Fetcher";
import {
  loggedUserState,
  popupState,
  selectedTypesState,
} from "../../../Store/atoms";
import Error from "../../Error";

import Table from "../../TablesDisplay/Table";

import "./styles.css";

export default () => {
  const user = useRecoilValue(loggedUserState);
  const setSelectedTypes = useSetRecoilState(selectedTypesState);

  const { data, error } = useSWR(
    BASE_URL + `user/${user.id}/favorites`,
    fetcher
  );
  setSelectedTypes([]);

  if (!data) {
    return <div>LOADING</div>;
  }

  if (error || data.status !== 200) {
    return (
      <Error
        code={data.status}
        message={data.data.message}
        button={{ route: "/", text: "back to homepage" }}
        resetUser={true}
      />
    );
  }

  const favorites = data.data as any;

  return (
    <div className="favorites">
      <div className="favorites-container">
        <div className="container-name">My tables</div>
        <div className="favorites-list">
          {favorites.map((favorite: any) => {
            return (
              <Table
                key={favorite.id}
                id={favorite.id}
                name={favorite.name}
                description={favorite.description}
                locked={favorite.locked}
                lastEdited={favorite.lastEdited}
                customer={favorite.customer.name}
                color={favorite.customer.color}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
